import type { JSX } from 'react';
/**
 * レポート集計期間セクション（Quiz/Diagnosis/Form 共通）
 * 集計期間表示 + 変更ボタン
 */
export default function WsReportTermSection(props: {
  reportDateFrom: string;
  reportDateTo: string;
  onModalReportTermOpen: () => void;
}): JSX.Element {
  const { reportDateFrom, reportDateTo, onModalReportTermOpen } = props;

  return (
    <section>
      <div className="section-header user-detail">
        <div className="container">
          <div className="d-md-flex d-flex-header card-detail">
            <div className="flex-shrink-0 flex-left"></div>
            <div className="flex-grow-1 flex-right">
              <ul className="list-inline list-btn mb-0">
                <ul className="list-unstyled list-inline mt-t">
                  <li className="list-inline-item me-1">
                    <b>集計期間</b>：{reportDateFrom} -{reportDateTo}
                  </li>
                  <li className="list-inline-item">
                    <button onClick={onModalReportTermOpen} className="btn btn-simple blue">
                      変更
                    </button>
                  </li>
                </ul>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
